import { getAdUsers } from "../../../types/defaultObjs/activeDirectoryObjs";
import { GroupLabelsEnum } from "../../../types/permissionTypes";
import { User, UserProps } from "../../../types/userTypes";
import { MOCK_MV51, MOCK_MV77 } from "../genericMocks";

export const mockUser: User = {
  user_id: 1,
  name: "Joan Daniels",
  mail: "Joan.Daniels@modec.com",
  position: "External Consultant",
};

export const mockUserProcessSafetyLead: User = {
  user_id: getAdUsers()[0].user_id,
  mail: getAdUsers()[0].mail,
  name: getAdUsers()[0].name,
  position: GroupLabelsEnum.PROCESS_SAFETY_LEAD,
};

export const mockUserOpsManager: User = {
  user_id: getAdUsers()[2].user_id,
  mail: getAdUsers()[2].mail,
  name: getAdUsers()[2].name,
  position: GroupLabelsEnum.OPS_MANAGER,
};

export const mockUserExternal: User = {
  user_id: getAdUsers()[3].user_id,
  mail: getAdUsers()[3].mail,
  name: getAdUsers()[3].name,
  position: mockUser.position,
};

export const mockUserExternalConsultant: User = {
  user_id: getAdUsers()[4].user_id,
  mail: getAdUsers()[4].mail,
  name: getAdUsers()[4].name,
  position: mockUser.position,
};

export const mockUserInfo: UserProps = {
  ...mockUser,
  last_login: null,
  permissions: GroupLabelsEnum.OPS_MANAGER,
  token: "",
  user_id: "52",
  vessel_role_permission_list: [
    {
      cd_vessel: MOCK_MV77,
      due_date: null,
      permission_list: [],
      role_id: 6,
      role_name: GroupLabelsEnum.OPS_MANAGER,
    },
    {
      cd_vessel: MOCK_MV51,
      due_date: null,
      permission_list: [],
      role_id: 6,
      role_name: "ROLES.OIM",
    },
  ],
  last_uuid: "",
  emails: [],
  email: "",
  scp: "",
  oid: "",
  exp: 0,
  iat: 0,
};

export const mockUserWithoutPermissions: UserProps = {
  last_login: null,
  mail: "Lewis.Clayton@modec.com",
  name: "Lewis Clayton",
  permissions: GroupLabelsEnum.OPS_MANAGER,
  position: "External Consultant",
  token: "",
  user_id: "22",
  vessel_role_permission_list: [
    {
      cd_vessel: MOCK_MV77,
      due_date: null,
      permission_list: [],
      role_id: 8,
      role_name: "ROLES.OPS_MANAGER",
    },
  ],
  last_uuid: "",
  emails: [],
  email: "",
  scp: "",
  oid: "",
  exp: 0,
  iat: 0,
};
